import PublicNavigationLocations from "core/navigation/PublicNavigationLocations";
import DashboardNavigationLocations from "core/navigation/DashboardNavigationLocations";
import browserPaths from "../../browserPaths";

export default class MapBrowserPath {
  static mapToBrowserPath(
    location: PublicNavigationLocations | DashboardNavigationLocations,
  ): string {
    switch (location) {
      case PublicNavigationLocations.HOME:
        return browserPaths.HOME;
      case PublicNavigationLocations.FIRST_LOGIN_RESET_PASSWORD:
        return browserPaths.FIRST_LOGIN_RESET_PASSWORD;
      case DashboardNavigationLocations.DASHBOARD:
        return browserPaths.DASHBOARD.HOME;
      case DashboardNavigationLocations.COMMERCIAL_DASHBOARD:
        return browserPaths.DASHBOARD.COMMERCIAL_DASHBOARD;
      case DashboardNavigationLocations.AGENCE_DASHBOARD:
        return browserPaths.DASHBOARD.AGENCE_DASHBOARD;
      case DashboardNavigationLocations.COMPLIANCE_DASHBOARD:
        return browserPaths.DASHBOARD.COMPLIANCE_DASHBOARD;
      case DashboardNavigationLocations.CONFORMITE_DASHBOARD:
        return browserPaths.DASHBOARD.CONFORMITE_DASHBOARD;
      // case DashboardNavigationLocations.CREATE_ACCOUNT:
      //   return browserPaths.DASHBOARD.CREATE_ACCOUNT;
      case DashboardNavigationLocations.PROSPECTS:
        return browserPaths.DASHBOARD.PROSPECTS;
      case DashboardNavigationLocations.CLIENT_360:
        return browserPaths.DASHBOARD.CLIENT_360;
      case DashboardNavigationLocations.PROFIL:
        return browserPaths.DASHBOARD.PROFIL;
      case DashboardNavigationLocations.ROLES_AND_RIGHTS:
        return browserPaths.DASHBOARD.ROLES_AND_RIGHTS;
      case DashboardNavigationLocations.NOUVELLE_DEMANDE:
        return browserPaths.DASHBOARD.NOUVELLE_DEMANDE;
      case DashboardNavigationLocations.CREATE_PROSPECT:
        return browserPaths.DASHBOARD.CREATE_PROSPECT;
      case DashboardNavigationLocations.CREATE_PROSPECT_PP:
        return browserPaths.DASHBOARD.CREATE_PROSPECT_PP;
      case DashboardNavigationLocations.CREATE_PROSPECT_PM:
        return browserPaths.DASHBOARD.CREATE_PROSPECT_PM;
      case DashboardNavigationLocations.ONBOARDING:
        return browserPaths.DASHBOARD.ONBOARDING;
      case DashboardNavigationLocations.PM_ONBOARDING:
        return browserPaths.DASHBOARD.PM_ONBOARDING;
      case DashboardNavigationLocations.IDENTITY_REPLACEMENT:
        return browserPaths.DASHBOARD.IDENTITY_REPLACEMENT;
      case DashboardNavigationLocations.RISK_ENTITY_REFERENTIAL:
        return browserPaths.DASHBOARD.RISK_ENTITY_REFERENTIAL;
      case DashboardNavigationLocations.COMPLIANCE_L1_REVIEW:
        return browserPaths.DASHBOARD.COMPLIANCE_L1_REVIEW;
      case DashboardNavigationLocations.COMPLIANCE_L1_REVIEW_DETAIL:
        return browserPaths.DASHBOARD.COMPLIANCE_L1_REVIEW_DETAIL;
      case DashboardNavigationLocations.COMPLIANCE_P4_VALIDATION:
        return browserPaths.DASHBOARD.COMPLIANCE_P4_VALIDATION;
      case DashboardNavigationLocations.COMPLIANCE_EDD:
        return browserPaths.DASHBOARD.COMPLIANCE_EDD;
      case DashboardNavigationLocations.COMPLIANCE_EDD_DETAIL:
        return browserPaths.DASHBOARD.COMPLIANCE_EDD_DETAIL;
      case DashboardNavigationLocations.PLATFORM_SETTINGS:
        return browserPaths.DASHBOARD.PLATFORM_SETTINGS;
      case DashboardNavigationLocations.AGENCES:
        return browserPaths.DASHBOARD.AGENCES;
      default:
        throw new Error(`Unknown location: ${location}`);
    }
  }

  static mapToBrowserRelativePath(
    location: PublicNavigationLocations | DashboardNavigationLocations,
  ): string {
    switch (location) {
      case DashboardNavigationLocations.DASHBOARD:
        return browserPaths.DASHBOARD.HOME_RELATIVE;
      case DashboardNavigationLocations.COMMERCIAL_DASHBOARD:
        return browserPaths.DASHBOARD.COMMERCIAL_DASHBOARD_RELATIVE;
      case DashboardNavigationLocations.AGENCE_DASHBOARD:
        return browserPaths.DASHBOARD.AGENCE_DASHBOARD_RELATIVE;
      case DashboardNavigationLocations.COMPLIANCE_DASHBOARD:
        return browserPaths.DASHBOARD.COMPLIANCE_DASHBOARD_RELATIVE;
      case DashboardNavigationLocations.CONFORMITE_DASHBOARD:
        return browserPaths.DASHBOARD.CONFORMITE_DASHBOARD_RELATIVE;
      // case DashboardNavigationLocations.CREATE_ACCOUNT:
      //   return browserPaths.DASHBOARD.CREATE_ACCOUNT_RELATIVE;
      case DashboardNavigationLocations.PROSPECTS:
        return browserPaths.DASHBOARD.PROSPECTS_RELATIVE;
      case DashboardNavigationLocations.CLIENT_360:
        return browserPaths.DASHBOARD.CLIENT_360_RELATIVE;
      case DashboardNavigationLocations.PROFIL:
        return browserPaths.DASHBOARD.PROFIL_RELATIVE;
      case DashboardNavigationLocations.ROLES_AND_RIGHTS:
        return browserPaths.DASHBOARD.ROLES_AND_RIGHTS_RELATIVE;
      case DashboardNavigationLocations.NOUVELLE_DEMANDE:
        return browserPaths.DASHBOARD.NOUVELLE_DEMANDE_RELATIVE;
      case DashboardNavigationLocations.CREATE_PROSPECT:
        return browserPaths.DASHBOARD.CREATE_PROSPECT_RELATIVE;
      case DashboardNavigationLocations.CREATE_PROSPECT_PP:
        return browserPaths.DASHBOARD.CREATE_PROSPECT_PP_RELATIVE;
      case DashboardNavigationLocations.CREATE_PROSPECT_PM:
        return browserPaths.DASHBOARD.CREATE_PROSPECT_PM_RELATIVE;
      case DashboardNavigationLocations.ONBOARDING:
        return browserPaths.DASHBOARD.ONBOARDING_RELATIVE;
      case DashboardNavigationLocations.PM_ONBOARDING:
        return browserPaths.DASHBOARD.PM_ONBOARDING_RELATIVE;
      case DashboardNavigationLocations.IDENTITY_REPLACEMENT:
        return browserPaths.DASHBOARD.IDENTITY_REPLACEMENT_RELATIVE;
      case DashboardNavigationLocations.RISK_ENTITY_REFERENTIAL:
        return browserPaths.DASHBOARD.RISK_ENTITY_REFERENTIAL_RELATIVE;
      case DashboardNavigationLocations.COMPLIANCE_L1_REVIEW:
        return browserPaths.DASHBOARD.COMPLIANCE_L1_REVIEW_RELATIVE;
      case DashboardNavigationLocations.COMPLIANCE_L1_REVIEW_DETAIL:
        return browserPaths.DASHBOARD.COMPLIANCE_L1_REVIEW_DETAIL_RELATIVE;
      case DashboardNavigationLocations.COMPLIANCE_P4_VALIDATION:
        return browserPaths.DASHBOARD.COMPLIANCE_P4_VALIDATION_RELATIVE;
      case DashboardNavigationLocations.COMPLIANCE_EDD:
        return browserPaths.DASHBOARD.COMPLIANCE_EDD_RELATIVE;
      case DashboardNavigationLocations.COMPLIANCE_EDD_DETAIL:
        return browserPaths.DASHBOARD.COMPLIANCE_EDD_DETAIL_RELATIVE;
      case DashboardNavigationLocations.PLATFORM_SETTINGS:
        return browserPaths.DASHBOARD.PLATFORM_SETTINGS_RELATIVE;
      case DashboardNavigationLocations.AGENCES:
        return browserPaths.DASHBOARD.AGENCES_RELATIVE;
      default:
        throw new Error(`Unknown location: ${location}`);
    }
  }
}
